module.exports = __webpack_public_path__ + "67ed0bf06ac13759ac79588937cc5102.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-30.png
// module id = 1782
// module chunks = 0